if (!customElements.get('pf-scroll-rail')) {
  customElements.define(
    'pf-scroll-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pf-track]');
        this.prevButton = this.querySelector('[data-pf-prev]');
        this.nextButton = this.querySelector('[data-pf-next]');

        if (!this.track) return;

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.scrollByCard(1));
        }
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('[data-pf-card]');
        const distance = card ? card.getBoundingClientRect().width + 18 : 300;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }
    }
  );
}

// Only plays a video while it's actually visible, so a row of several
// autoplaying videos doesn't try to decode all of them at once — that
// simultaneous decode load is what causes stutter/freezing on phones.
if (!window.pfVideoObserverInit) {
  window.pfVideoObserverInit = true;

  const initPfVideoObserver = () => {
    const videos = document.querySelectorAll('.pf-video-el');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      },
      { rootMargin: '60px', threshold: 0.25 }
    );

    videos.forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPfVideoObserver);
  } else {
    initPfVideoObserver();
  }
}
